import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SWOffering from "@/pages/SWOffering";

export const Route = createFileRoute("/en/services/software-solutions-services/ai-ml-compliance")({
  head: () => buildRouteHead("/en/services/software-solutions-services/ai-ml-compliance"),
  component: SWOffering,
});

